import { getCookie, isEmpty } from "utils/browserHelper"
export const checkIsIntlFlexMax = (meta, abTest) => {
    if (isEmpty(meta) || isEmpty(abTest)) {
        return false
    }
    const {intlflexmax: intlFlexCookie} = abTest
    const { intlCTFlexEnabled } = meta
    return intlCTFlexEnabled && intlFlexCookie === 'b'
}

export const findSelectedFareIndex = (fares) => {
    for (let i = 0; i < fares.length; i++) {
        if (fares[i]?.selected) {
            return i
        }
    }
    return 0
}